import React from 'react';
import { Spinner, Frame, Text, BlockStack } from '@shopify/polaris';
import './Loading.css'; // We'll create this file

const Loading = () => {
  return (
    <Frame>
      <div className="loading-container">
        <BlockStack gap="400" alignment="center">
          <div className="spinner-wrapper">
            <Spinner size="large" accessibilityLabel="Loading" hasFocusableParent={false} />
          </div>
          <Text variant="headingMd" as="h4">
            Loading application...
          </Text>
        </BlockStack>
      </div>
    </Frame>
  );
};

export default Loading; 